<!--  -->
<template>
  <div class="layout_view">
    <router-view></router-view>
  </div>
</template>

<script>
import {
  getUserInfo,
  regUser,
  logout,
  getPortalConfig,
  getLoginApi,
} from "@/api/home";
export default {
  components: {},
  name: "Layout",
  data() {
    return {
      popupShow: false,
      userInfo: {
        name: "",
        photo: "",
      },
      portalInfo: {},
    };
  },
  watch: {},
  methods: {
    //登录
    loginPortal() {
      window.location.href = window.g.base_url + window.g.loginUrl;
    },

    async logout() {
      const res = await logout();
      window.location.replace(res);
    },

    handleCommand(command) {
      if (command == "out") {
        this.logout();
      }
      if (command == "userCenter") {
        if (window.g.personalCenterUrl) {
          window.location.href = window.g.personalCenterUrl;
        }
      }
    },

    getUserInfo() {
      getUserInfo().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else {
          this.loginPortal();
        }
      });
    },

    //查询配置信息
    async getPortalConfig() {
      getPortalConfig().then((res) => {
        this.portalInfo = res.data;
      });
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  created() {}, //生命周期 - 创建完成（可以访问当前this实例）
  beforeMount() {}, //生命周期 - 挂载之前
  mounted() {
    // this.getUserInfo();
    // this.getPortalConfig();
  }, //生命周期 - 挂载完成（可以访问DOM元素）
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  deactivated() {}, //如果页面有keep-alive缓存功能，当组件被移除时，触发钩子函数deactivated
};
</script>
<style scoped lang="less">
.layout_view {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
